import Echo from 'laravel-echo';
/* eslint-disable */
import Pusher from 'pusher-js';
/* eslint-enable */

// Channels routes/channels.php authorizes for a CrewTaskToken actor. Keep this
// in sync with the crew branches in that file so a crew tab uses its bearer for
// each. The crew bearer is rejected by the backend on every other channel.
const CREW_CHANNEL_PREFIXES = ['private-inventory.conditions.', 'private-inventory.ai-analysis.'];

/**
 * Resolve a private-channel broadcasting/auth request based on the channel and
 * the tab's session.
 *
 * A crew share-link tab carries its per-task bearer in sessionStorage and talks
 * to the API through crewAxios, whose interceptor attaches that bearer and
 * resolves the tenant-prefixed base URL (`/{slug}/api/v1`). A staff tab uses the
 * localStorage CRM session via tenantAxios.
 *
 * The crew bearer only authorizes the crew's own channels (CREW_CHANNEL_PREFIXES)
 * — it is rejected on every other channel by the backend. So we route by channel
 * name: crew channels go through the crew bearer, everything else through the
 * staff session. This matters when a staff session and a crew bearer coexist in
 * the same tab (e.g. a logged-in field-staff user opens a crew link): staff
 * channels such as `private-call.tenant.{id}` must keep using the staff bearer,
 * otherwise the crew bearer leaks onto them and the auth fails.
 */
export const authorizeChannel = (channel, socketId, callback) => {
    const crewBearer = sessionStorage.getItem('crew_bearer');
    const isCrewChannel = CREW_CHANNEL_PREFIXES.some((prefix) => channel.name.startsWith(prefix));

    if (crewBearer && isCrewChannel) {
        window.crewAxios
            .post('/broadcasting/auth', {
                socket_id: socketId,
                channel_name: channel.name,
            })
            .then((response) => {
                callback(false, response.data);
            })
            .catch((error) => {
                console.debug(`crew ws error auth response ${socketId} ${channel.name}`, error);

                callback(true, error);
            });

        return;
    }

    const token = localStorage.getItem('bearer');
    const tenantSlug = localStorage.getItem('tenantSlug');

    window.tenantAxios
        .post(
            '/broadcasting/auth',
            {
                socket_id: socketId,
                channel_name: channel.name,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'X-Tenant': `${tenantSlug}`,
                },
            },
        )
        .then((response) => {
            console.debug(
                `(tenant ${tenantSlug}) ws success auth response for ${socketId} ${channel.name}`,
                response.data,
            );

            callback(false, response.data);
        })
        .catch((error) => {
            console.debug(`(tenant ${tenantSlug}) ws error auth response ${socketId} ${channel.name}`, error);

            callback(true, error);
        });
};

export default (app) => {
    const echo = new Echo({
        broadcaster: 'pusher',
        key: import.meta.env.VITE_PUSHER_APP_KEY,

        // For local development with Soketi, we need to specify the host
        ...(import.meta.env.VITE_ENV === 'local' ?
            { wsHost: import.meta.env.VITE_PUSHER_HOST, cluster: import.meta.env.VITE_PUSHER_CLUSTER || 'mt1' }
        :   { cluster: import.meta.env.VITE_PUSHER_CLUSTER }),
        wsPort: import.meta.env.VITE_PUSHER_PORT,
        wssPort: import.meta.env.VITE_PUSHER_PORT,
        forceTLS: import.meta.env.VITE_PUSHER_SCHEME === 'https',
        encrypted: import.meta.env.VITE_PUSHER_SCHEME === 'https',
        disableStats: true,
        enabledTransports: ['ws', 'wss'],
        authorizer: (channel) => {
            return {
                authorize: (socketId, callback) => authorizeChannel(channel, socketId, callback),
            };
        },
    });

    app.config.globalProperties.$echo = echo;
    window.echo = echo;
};
